import React, { FC } from 'react';
import { VideoContainer } from './VideoContainer';
import { TutorialContainer } from './TutorialContainer';
import { BannerContainer } from './BannerContainer';
import { DocumentContainer } from './DocumentContainer';

import styles from './styles.module.scss';

interface ITabContentSeller {
  data: {
    title: string;
    id: number,
  },
  langBanner: string;
}

export const TabContentTools:FC<ITabContentSeller> = ({
  data,
  langBanner,
}) => (
  <div className={styles.tools_content_container}>
    {data.id === 1 && (
    <VideoContainer 
      langBanner={langBanner}
    />
    )}
    {data.id === 2 && (
      <TutorialContainer
        langBanner={langBanner}
      />
    )}
    {data.id === 3 && (
    <div className={styles.instruments_banner_container}>
      <BannerContainer
        pack={2}
        langBanner={langBanner}
      />
      <BannerContainer
        pack={3}
        langBanner={langBanner}
      />
      <BannerContainer
        pack={4}
        langBanner={langBanner}
      />
    </div>
    )}
    {data.id === 4 && (
      <DocumentContainer
        langBanner={langBanner}
      />
    )}
  </div>
);
